import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AttachmentCategoryCell } from './AttachmentCategoryCell';
import { toAttachmentRow } from '../utils/toAttachmentRow';
const BUILDING_ID = 42;
const identityTranslate = (key) => key;
const OPTIONS = [
    { id: null, label: 'No category' },
    { id: 1, label: 'Reports' },
    { id: 2, label: 'Permits' },
    { id: 3, label: 'Photos' }
];
function withRow(apiRow) {
    return function Story() {
        const client = useMemo(() => new QueryClient({ defaultOptions: { queries: { retry: false } } }), []);
        const item = toAttachmentRow(apiRow, identityTranslate);
        return (React.createElement(QueryClientProvider, { client: client },
            React.createElement(AttachmentCategoryCell, { item: item, buildingId: BUILDING_ID, options: OPTIONS })));
    };
}
const meta = {
    title: 'Features/BuildingAttachments/AttachmentCategoryCell',
    tags: ['autodocs'],
    parameters: { layout: 'padded' }
};
export default meta;
/** Click to open a searchable dropdown of every tenant category (E2E-28). */
export const WithCategory = {
    render: withRow({
        id: 1,
        name: 'report.pdf',
        attachmentCategoryId: 1,
        categoryName: 'Reports',
        createdAt: '2026-09-15T14:30:00-04:00',
        fileSize: 655360,
        isPrivate: false,
        showOnCustomerPortal: true,
        url: 'https://cdn.example.com/report.pdf'
    })
};
/** The "No category" sentinel is selected by default when the row is uncategorized. */
export const Uncategorized = {
    render: withRow({
        id: 2,
        name: 'panel-photo.jpg',
        attachmentCategoryId: null,
        categoryName: null,
        createdAt: '2026-09-15T14:30:00-04:00',
        fileSize: 51200,
        isPrivate: false,
        showOnCustomerPortal: false,
        url: 'https://cdn.example.com/panel-photo.jpg'
    })
};
